const myHealthURLs = {
  test: {
    nl: 'https://wwwint.mijngezondheid.belgie.be',
    fr: 'https://wwwint.masante.belgique.be',
    de: 'https://wwwint.meinegesundheit.belgien.be'
  },
  acc: {
    nl: 'https://wwwacc.mijngezondheid.belgie.be',
    fr: 'https://wwwacc.masante.belgique.be',
    de: 'https://wwwacc.meinegesundheit.belgien.be/'
  },
  prod: {
    nl: 'https://www.mijngezondheid.belgie.be',
    fr: 'https://www.masante.belgique.be',
    de: 'https://www.meinegesundheit.belgien.be/'
  }
};

const rizivURLs = {
  nl: 'https://www.inami.fgov.be/nl/toepassingen/Paginas/progezondheid.aspx',
  fr: 'https://www.inami.fgov.be/fr/programmes-web/Pages/prosante.aspx',
  de: 'https://www.inami.fgov.be/fr/programmes-web/Pages/prosante.aspx'
};

const contactURLs = {
  nonProfessional: {
    nl: 'https://apps.health.belgium.be/ordsm/01/f?p=120:13::CHANGELANGUAGE:YES::FSP_LANGUAGE_PREFERENCE:nl',
    fr: 'https://apps.health.belgium.be/ordsm/01/f?p=120:13::CHANGELANGUAGE:YES::FSP_LANGUAGE_PREFERENCE:fr',
    de: 'https://apps.health.belgium.be/ordsm/01/f?p=120:13::CHANGELANGUAGE:YES::FSP_LANGUAGE_PREFERENCE:de'
  },
  professional: {
    test: {
      nl: 'https://webapps-v.riziv-inami.fgov.be/MyPortalFrontOffice/nl/HCW/Contact',
      fr: 'https://webapps-v.riziv-inami.fgov.be/MyPortalFrontOffice/fr/HCW/Contact',
      de: 'https://webapps-v.riziv-inami.fgov.be/MyPortalFrontOffice/fr/HCW/Contact'
    },
    prod: {
      nl: 'https://webapps.riziv-inami.fgov.be/MyPortalFrontOffice/nl/HCW/Contact',
      fr: 'https://webapps.riziv-inami.fgov.be/MyPortalFrontOffice/fr/HCW/Contact',
      de: 'https://webapps.riziv-inami.fgov.be/MyPortalFrontOffice/fr/HCW/Contact'
    }
  }
};

export const CONFIGURATION_DATA = {
  environments: [
    {
      env: 'local',
      domain: ['localhost:4200', '127.0.0.1:4200']
    },
    {
      env: 'test',
      domain: ['vidis.test.paas.vasdc.be']
    },
    {
      env: 'testprofessional',
      domain: ['vidis-professional.test.paas.vasdc.be']
    },
    {
      env: 'int',
      domain: ['vidis.int.paas.vasdc.be']
    },
    {
      env: 'intpub',
      domain: ['vidis.int.pub.vascloud.be']
    },
    {
      env: 'intprofessional',
      domain: ['vidis-professional.int.pub.vascloud.be']
    },
    {
      env: 'accha',
      domain: ['vidis.acc.vasha.be']
    },
    {
      env: 'accprofessionalha',
      domain: ['vidis-professional.acc.vasha.be']
    },
    {
      env: 'acchaIn',
      domain: ['vidis.acc.in.vasha.be']
    },
    {
      env: 'accprofessionalhaIn',
      domain: ['vidis-professional.acc.in.vasha.be']
    },
    {
      env: 'acchaUp',
      domain: ['vidis.acc.up.vasha.be']
    },
    {
      env: 'accprofessionalhaUp',
      domain: ['vidis-professional.acc.up.vasha.be']
    },
    {
      env: 'prodha',
      domain: ['vidis.vasha.be']
    },
    {
      env: 'prodprofessionalha',
      domain: ['vidis-professional.vasha.be']
    },
    {
      env: 'prodhaIn',
      domain: ['vidis.in.vasha.be']
    },
    {
      env: 'prodprofessionalhaIn',
      domain: ['vidis-professional.in.vasha.be']
    },
    {
      env: 'prodhaUp',
      domain: ['vidis.up.vasha.be']
    },
    {
      env: 'prodprofessionalhaUp',
      domain: ['vidis-professional.up.vasha.be']
    }
  ],
  variables: {
    local: {
      apiUrl: 'http://vidis-fake-api.test.paas.vasdc.be',
      myHealthUrl:  myHealthURLs.test,
      rizivURL: rizivURLs,
      contactURL: contactURLs.nonProfessional,
      keycloakAuthServerUrl: 'http://vasiam.test.paas.vasdc.be/auth',
      keycloakRealm: 'MOOSE_NIHII',
      keycloakClientId: 'nihdi-vidis',
      env: 'local',
      maxIdleTimeInSeconds: 900,
    },
    test: {
      apiUrl: 'http://vidis-fake-api.test.paas.vasdc.be',
      myHealthUrl: myHealthURLs.test,
      rizivURL: rizivURLs,
      contactURL: contactURLs.nonProfessional,
      keycloakAuthServerUrl: 'http://vasiam.test.paas.vasdc.be/auth',
      keycloakRealm: 'MOOSE_NIHII',
      keycloakClientId: 'nihdi-vidis',
      env: 'test',
      maxIdleTimeInSeconds: 900,
    },
    testprofessional: {
      apiUrl: 'http://vidis-fake-api.test.paas.vasdc.be',
      myHealthUrl: myHealthURLs.test,
      rizivURL: rizivURLs,
      contactURL: contactURLs.professional.test,
      keycloakAuthServerUrl: 'http://vasiam.test.paas.vasdc.be/auth',
      keycloakRealm: 'MOOSE_NIHII',
      keycloakClientId: 'nihdi-vidis-caregiver',
      env: 'test',
      maxIdleTimeInSeconds: 900,
    },
    int: {
      apiUrl: 'https://vidis-api.int.pub.vascloud.be/REST/vidis',
      myHealthUrl: {
        fr: 'http://vidis.int.paas.vasdc.be',
        nl: 'http://vidis.int.paas.vasdc.be',
        de: 'http://vidis.int.paas.vasdc.be'
      },
      rizivURL:{
        fr: 'http://vidis.int.paas.vasdc.be',
        nl: 'http://vidis.int.paas.vasdc.be',
        de: 'http://vidis.int.paas.vasdc.be'
      },
      contactURL: contactURLs.nonProfessional,
      keycloakAuthServerUrl: 'https://api-acpt.ehealth.fgov.be/auth/',
      keycloakRealm: 'healthcare',
      keycloakClientId: 'nihdi-vidis',
      env: 'int',
      maxIdleTimeInSeconds: 900,
    },
    intpub: {
      apiUrl: 'https://vidis-api.int.pub.vascloud.be/REST/vidis',
      myHealthUrl: {
        fr: 'https://vidis.int.pub.vascloud.be',
        nl: 'https://vidis.int.pub.vascloud.be',
        de: 'https://vidis.int.pub.vascloud.be'
      },
      rizivURL: {
        fr: 'https://vidis.int.pub.vascloud.be',
        nl: 'https://vidis.int.pub.vascloud.be',
        de: 'https://vidis.int.pub.vascloud.be'
      },
      contactURL: contactURLs.nonProfessional,
      keycloakAuthServerUrl: 'https://api-acpt.ehealth.fgov.be/auth/',
      keycloakRealm: 'healthcare',
      keycloakClientId: 'nihdi-vidis',
      env: 'intpub',
      maxIdleTimeInSeconds: 900,
    },
    intprofessional: {
      apiUrl: 'https://vidis-api.int.pub.vascloud.be/REST/vidis',
      myHealthUrl: {
        fr: 'https://vidis-professional.int.pub.vascloud.be',
        nl: 'https://vidis-professional.int.pub.vascloud.be',
        de: 'https://vidis-professional.int.pub.vascloud.be'
      },
      rizivURL: {
        fr: 'https://vidis-professional.int.pub.vascloud.be',
        nl: 'https://vidis-professional.int.pub.vascloud.be',
        de: 'https://vidis-professional.int.pub.vascloud.be'
      },
      contactURL: contactURLs.professional.test,
      keycloakAuthServerUrl: 'https://api-acpt.ehealth.fgov.be/auth/',
      keycloakRealm: 'healthcare',
      keycloakClientId: 'nihdi-vidis-caregiver',
      env: 'intpub',
      maxIdleTimeInSeconds: 900,
    },
    accha: {
      apiUrl: 'https://vidis-api.acc.vasha.be/REST/vidis',
      myHealthUrl: myHealthURLs.acc,
      rizivURL: rizivURLs,
      contactURL: contactURLs.nonProfessional,
      keycloakAuthServerUrl: 'https://api-acpt.ehealth.fgov.be/auth/',
      keycloakRealm: 'healthcare',
      keycloakClientId: 'nihdi-vidis',
      env: 'accpub',
      maxIdleTimeInSeconds: 900,
    },
    accprofessionalha: {
      apiUrl: 'https://vidis-api.acc.vasha.be/REST/vidis',
      myHealthUrl: myHealthURLs.acc,
      rizivURL:rizivURLs,
      contactURL: contactURLs.professional.test,
      keycloakAuthServerUrl: 'https://api-acpt.ehealth.fgov.be/auth/',
      keycloakRealm: 'healthcare',
      keycloakClientId: 'nihdi-vidis-caregiver',
      env: 'accpub',
      maxIdleTimeInSeconds: 900,
    },
    acchaIn: {
      apiUrl: 'https://vidis-api.acc.in.vasha.be/REST/vidis',
      myHealthUrl: myHealthURLs.acc,
      rizivURL: rizivURLs,
      contactURL: contactURLs.nonProfessional,
      keycloakAuthServerUrl: 'https://api-acpt.ehealth.fgov.be/auth/',
      keycloakRealm: 'healthcare',
      keycloakClientId: 'nihdi-vidis',
      env: 'accpub',
      maxIdleTimeInSeconds: 900,
    },
    accprofessionalhaIn: {
      apiUrl: 'https://vidis-api.acc.in.vasha.be/REST/vidis',
      myHealthUrl: myHealthURLs.acc,
      rizivURL: rizivURLs,
      contactURL: contactURLs.professional.test,
      keycloakAuthServerUrl: 'https://api-acpt.ehealth.fgov.be/auth/',
      keycloakRealm: 'healthcare',
      keycloakClientId: 'nihdi-vidis-caregiver',
      env: 'accpub',
      maxIdleTimeInSeconds: 900,
    },
    acchaUp: {
      apiUrl: 'https://vidis-api.acc.up.vasha.be/REST/vidis',
      myHealthUrl: myHealthURLs.acc,
      rizivURL: rizivURLs,
      contactURL: contactURLs.nonProfessional,
      keycloakAuthServerUrl: 'https://api-acpt.ehealth.fgov.be/auth/',
      keycloakRealm: 'healthcare',
      keycloakClientId: 'nihdi-vidis',
      env: 'accpub',
      maxIdleTimeInSeconds: 900,
    },
    accprofessionalhaUp: {
      apiUrl: 'https://vidis-api.acc.vasha.be/REST/vidis',
      myHealthUrl: myHealthURLs.acc,
      rizivURL:rizivURLs,
      contactURL: contactURLs.professional.test,
      keycloakAuthServerUrl: 'https://api-acpt.ehealth.fgov.be/auth/',
      keycloakRealm: 'healthcare',
      keycloakClientId: 'nihdi-vidis-caregiver',
      env: 'accpub',
      maxIdleTimeInSeconds: 900,
    },
    prodha: {
      apiUrl: 'https://vidis-api.vasha.be/REST/vidis',
      myHealthUrl: myHealthURLs.prod,
      rizivURL: rizivURLs,
      contactURL:contactURLs.nonProfessional,
      keycloakAuthServerUrl: 'https://api.ehealth.fgov.be/auth/',
      keycloakRealm: 'healthcare',
      keycloakClientId: 'nihdi-vidis',
      env: 'prod',
      maxIdleTimeInSeconds: 900,
    },
    prodprofessionalha: {
      apiUrl: 'https://vidis-api.vasha.be/REST/vidis',
      myHealthUrl: myHealthURLs.prod,
      rizivURL: rizivURLs,
      contactURL: contactURLs.professional.prod,
      keycloakAuthServerUrl: 'https://api.ehealth.fgov.be/auth/',
      keycloakRealm: 'healthcare',
      keycloakClientId: 'nihdi-vidis-caregiver',
      env: 'prod',
      maxIdleTimeInSeconds: 900,
    },
    prodhaIn: {
      apiUrl: 'https://vidis-api.in.vasha.be/REST/vidis',
      myHealthUrl: myHealthURLs.prod,
      rizivURL: rizivURLs,
      contactURL: contactURLs.nonProfessional,
      keycloakAuthServerUrl: 'https://api.ehealth.fgov.be/auth/',
      keycloakRealm: 'healthcare',
      keycloakClientId: 'nihdi-vidis',
      env: 'prod',
      maxIdleTimeInSeconds: 900,
    },
    prodprofessionalhaIn: {
      apiUrl: 'https://vidis-api.in.vasha.be/REST/vidis',
      myHealthUrl: myHealthURLs.prod,
      rizivURL: rizivURLs,
      contactURL:contactURLs.professional.prod,
      keycloakAuthServerUrl: 'https://api.ehealth.fgov.be/auth/',
      keycloakRealm: 'healthcare',
      keycloakClientId: 'nihdi-vidis-caregiver',
      env: 'prod',
      maxIdleTimeInSeconds: 900,
    },
    prodhaUp: {
      apiUrl: 'https://vidis-api.up.vasha.be/REST/vidis',
      myHealthUrl: myHealthURLs.prod,
      rizivURL: rizivURLs,
      contactURL: contactURLs.nonProfessional,
      keycloakAuthServerUrl: 'https://api.ehealth.fgov.be/auth/',
      keycloakRealm: 'healthcare',
      keycloakClientId: 'nihdi-vidis',
      env: 'prod',
      maxIdleTimeInSeconds: 900,
    },
    prodprofessionalhaUp: {
      apiUrl: 'https://vidis-api.up.vasha.be/REST/vidis',
      myHealthUrl: myHealthURLs.prod,
      rizivURL: rizivURLs,
      contactURL: contactURLs.professional.prod,
      keycloakAuthServerUrl: 'https://api.ehealth.fgov.be/auth/',
      keycloakRealm: 'healthcare',
      keycloakClientId: 'nihdi-vidis-caregiver',
      env: 'prod',
      maxIdleTimeInSeconds: 900,
    }
  }
};
